import { useContext } from 'react';
import { AdminProjects } from '@platform/client';
import { AdminTableContext } from '../../AdminTable';
import { useQueryClient } from '@tanstack/react-query';
import { BatchImportModal } from '../../components/BatchImportModal';

const PROJECT_IMPORT_TEMPLATE =
  'https://movingworldspublic.blob.core.windows.net/public/project_import_template.csv';

export const ImportProjectsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const batchImportProjectMutation = AdminProjects.useBatchImportProjects({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...AdminProjects.getGetProjectsQueryKey({ ...adminQueryOptionsV2 })],
        });
      },
    },
  });

  return (
    <BatchImportModal
      recordType='projects'
      templateFileUrl={PROJECT_IMPORT_TEMPLATE}
      onClose={onClose}
      isOpen={isOpen}
      mutation={{
        ...batchImportProjectMutation,
        mutate: (file) => batchImportProjectMutation.mutate({ data: { file } }),
      }}
    />
  );
};
